import {
    TableFilterParams,
} from 'app/types/common.types'
import BulkUploadIcon from 'app/shared-components/TableControls/BulkUploadIcon'
import {
    useTableActionsContext,
} from 'app/shared-components/TableActionsContext'

type Props = {
    getFilterParams: () => TableFilterParams
    isMenuItem?: boolean
}

const BulkUploadButton = ({
    getFilterParams,
    isMenuItem = false,
}: Readonly<Props>) => {
    const {
        setBulkUploadData,
    } = useTableActionsContext()

    const handleClick = () => {
        setBulkUploadData(getFilterParams())
    }

    return (
        <BulkUploadIcon
            isMenuItem={isMenuItem}
            onClick={handleClick}
        />
    )
}

export default BulkUploadButton
